import { render, staticRenderFns } from "./MedidorForm.vue?vue&type=template&id=1a63d169&"
import script from "./MedidorForm.vue?vue&type=script&lang=js&"
export * from "./MedidorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports